<template>
  <div>
    <template v-for="item in menuList">
      <!-- 如果还有子菜单，继续递归 -->
      <el-submenu v-if="item.children && item.children.length" :key="item.id" :index="item.path || item.name">
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </template>
        <side-menu-item :menu-list="item.children" />
      </el-submenu>
      <el-menu-item v-else :key="item.id" :index="item.path">
        <i :class="item.icon"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SideMenuItem',
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  }
}
</script>